import { HistoryTableFilterContext } from 'src/utils/historyTables';

export const ALWAYS_TRUE_FILTER = () => true;

export interface HistoryDataState<T> {
	records: T[];
	totalCount: number;
	loading: boolean;
	initialHistoryLoaded: boolean;
}

export interface HistoryTableUIProps<T = unknown> {
	executePageChange: (newPage: number, uiPageSize?: number) => void;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	filterFn: (
		record: any,
		filterState: any,
		context?: HistoryTableFilterContext
	) => boolean;
	historyData: HistoryDataState<T>;
	noExpandAllButton?: boolean;
	tableContentWrapperClassName?: string;
}
